export default __webpack_public_path__ + "static/media/lipstick-soft-autumn.9d4ad28b.png";